<template>
  <div class="full">
    <div id="map" ref="map"></div>
  </div>
</template>

<script>

import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import MarkerClusterer from 'marker-clusterer-plus'
import markerImage from '../assets/marker.png'
import defaultImg from '../assets/default-img.png'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDFCl1qvN8gJ0YG_DaPzYVCb6R5gTM4wF4'
  }
})

export default {
  name: 'Maps',
  props: [
    'mode',
    'entreprises'
  ],
  data: () => ({
    map: null,
    markers: [],
    markerCluster: null,
    defaultImg: defaultImg
  }),
  async mounted() {
    await this.createMap()
    await this.createMarkers()
    await this.createCluster()
  },
  methods: {
    async createMap(){
      this.map = new window.google.maps.Map(this.$refs['map'], {
        center: {
          lat: 43.5,
          lng: 1.5
        },
        mapTypeId: 'roadmap',
        zoom: 8
      })
    },
    async createMarkers(){
      this.entreprises.forEach(entreprise => {
        if(entreprise.street && entreprise.city && entreprise.zip && entreprise.x_studio_map_latitude && entreprise.x_studio_map_longitude) {
          const location = {
            lat: entreprise.x_studio_map_latitude,
            lng: entreprise.x_studio_map_longitude
          }
          const address = `${entreprise.street} ${entreprise.zip} ${entreprise.city}`
            const contentString = `<div id="content" style="max-width:420px;">
              <div style="display:flex; flex-wrap: wrap; justify-content:space-between; margin-bottom: 10px; align-items: center;">
                <img style="height: 30px;width: auto;" src="${entreprise.x_studio_url_image_sur_wordpress ? entreprise.x_studio_url_image_sur_wordpress : defaultImg}">
                <p style="color: #ff0033;font-weight: 500;font-size: 16px; margin-right: 10px;">${entreprise.x_studio_field_k9Nz7}</p>
              </div>
              <div style="
                  padding: 5px 8px;
                  border: 4px solid #374ebd;
                  border-radius: 4px;
                  border-bottom-left-radius: 0;
                  border-bottom-right-radius: 0;
                  font-weight: 500;
                  color: #12204c;"
              >
                <p>${address}</p>
                <p>${entreprise.x_studio_description_courte}</p>
              </div>
              <a style="width: 100%;
                  background-color: #374ebd;
                  display: block;
                  text-align: center;
                  color: white;
                  padding: 10px 0;
                  text-transform: uppercase;
                  text-decoration: none;"
                target="_blank" href="https://digital113.fr/?p=${entreprise.x_studio_wordpress_id}">site web</a>
            </div>`;

            const infowindow = new window.google.maps.InfoWindow({
              content: contentString
            });

            const marker = new window.google.maps.Marker({
              position: location,
              icon: markerImage
            })

            marker.addListener('click', function() {
              infowindow.open(this.map, marker);
            });

            this.markers.push(marker)
          }
      })
    },
    async createCluster(){
      this.markerCluster = new MarkerClusterer(this.map, this.markers, {
        maxZoom: 18
      })
    }
  }
}
</script>

<style scoped>
  #map{
    height: 600px;
    background: gray;
  }
  .loader{
    position: absolute;
    top: calc(50% - 50px);
    left: calc(50% - 50px);
  }

  .link-company {
    width: 100%;
    background-color: #374ebd;
    display: block;
    text-align: center;
    color: white;
    padding: 10px 0;
    text-transform: uppercase;
    text-decoration: none;
  }
</style>
